const SubscriptionProducts = {
    ApplicationAccess: {
        TRACTIQ_SELF_STORAGE_MAX: 'ACCESS__TRACTIQ_SELFSTORAGE_MAX',
        TRACTIQ_SELF_STORAGE_PRO_PLUS: 'ACCESS__TRACTIQ_SELFSTORAGE_PRO_PLUS',
        TRACTIQ_SELF_STORAGE: 'ACCESS__TRACTIQ_SELFSTORAGE',
        TRACTIQ_SELF_STORAGE_STARTER_TIER: 'ACCESS__TRACTIQ_SELFSTORAGE_STARTER_TIER',
    },

    ApplicationAccessConfigurationOptions: {
        ENABLE_INTERNAL_TOOLS: 'ACCESS__TRACTIQ_SELFSTORAGE__ENABLE_INTERNAL_TOOLS',
        ENABLE_RAW_DATA_EXPORT: 'ACCESS__TRACTIQ_SELFSTORAGE__ENABLE_RAW_DATA_EXPORT',
        ENABLE_OPERATING_PERFORMANCE_PAGE:
            'ACCESS__TRACTIQ_SELFSTORAGE__ENABLE_OPERATING_PERFORMANCE_PAGE',
        ENABLE_SITE_ANALYSIS_API: 'ACCESS__TRACTIQ_SELFSTORAGE__ENABLE_SITE_ANALYSIS_API',
        ENABLE_FINANCIAL_DATA_EXPORT: 'ACCESS__TRACTIQ_SELFSTORAGE__ENABLE_FINANCIAL_DATA_EXPORT',
    },

    DataPackages: {
        TRACTIQ_SELF_STORAGE_BASE: 'DATA_PACKAGE__TRACTIQ_SELFSTORAGE_BASE',
        PROPRIETARY_SINGLE_LOCATION_REPORT: 'DATA_PACKAGE__PROPRIETARY_SINGLE_LOCATION_REPORT',
    },

    ProductTypes: {
        MAX_PRODUCT: 'MAX',
        PRO_PLUS_PRODUCT: 'PRO_PLUS',
        PROFESSIONAL_PRODUCT: 'PRO',
        STARTER_PRODUCT: 'STARTER_PRODUCT',
        OTHER: '/',
    },
};

export default SubscriptionProducts;
